import { initReactI18next } from "react-i18next";

import i18n from "i18next";

import { LANGUAGES } from "../shared";
import de from "./locales/de.json";
import en from "./locales/en.json";
import es from "./locales/es.json";
import fr from "./locales/fr.json";
import hu from "./locales/hu.json";
import it from "./locales/it.json";
import lt from "./locales/lt.json";
import pl from "./locales/pl.json";

export const resources = {
  [LANGUAGES.English]: { translation: en },
  [LANGUAGES.Lithuanian]: { translation: lt },
  [LANGUAGES.Spanish]: { translation: es },
  [LANGUAGES.French]: { translation: fr },
  [LANGUAGES.German]: { translation: de },
  [LANGUAGES.Italian]: { translation: it },
  [LANGUAGES.Polish]: { translation: pl },
  [LANGUAGES.Hungarian]: { translation: hu }
} as const;

i18n.use(initReactI18next).init({
  lng: LANGUAGES.English,
  fallbackLng: LANGUAGES.English,
  resources,
  keySeparator: "##",
  interpolation: {
    escapeValue: false
  },
  returnEmptyString: false,
  react: {
    useSuspense: true
  }
});
